<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column">
        <h3>Fillable Ledger</h3>
        <callout type="info">
          You must complete the fillable ledger to submit your application. The ledger or rent roll is a detailed list of past due rent and fees. Please begin with the most recent month an amount is owed. <br> <br>
          For landlords receiving rent payments from Philadelphia Housing Authority (PHA), Housing Choice Voucher (HCV) program, etc., only include the rent portion the tenant is responsible for paying. The TFA payment will not include rent owed by PHA, HCV, or alternative housing subsidy programs.
          <br>
          <br>
          Attention: the ledger balance must match the amount list as back rent or fees (arrears) owed on the previous page. If you need to adjust this amount, please revise the amount on the previous page. The arrears amount you entered was: ${{ Arrears }}.
        </callout>
      </div>
    </div>
    Arrears: ${{ Arrears }}<br>
    Ledger Amount Total: ${{ calculateBalance }}<br>
    <!-- Number of Entries Selected: {{ LedgerEntry.NumberOfLedgerEntriesSelected }} -->
    <div
      v-if="Arrears != calculateBalance && isNaN(calculateBalance) == false && entriesGenerated == true"
      class="column"
    >
      <callout type="danger">
        The ledger amount doesn't match the arrears.
      </callout>
      <span>Total Arrears: {{ Arrears }}</span>
    </div>
    <div class="columns">
      <div class="column">
        <vee-dropdown
          v-model="LedgerEntry.NumberOfLedgerEntriesSelected"
          label="Select the number of ledger entries"
          :options="LedgerEntry.ledgerEntryList.map((i) => i.id.toString())"
          placeholder="How many ledger entries are you entering"
          required
          rules="required"
          mode="eager"
          @keydown="entriesSelected()"
        />
      </div>
    </div>
    <div
      v-for="ledgerEntryObj in LedgerEntry.ledgerEntryList"
      :key="ledgerEntryObj.id"
      :class="`entry-information-${ledgerEntryObj.id}`"
    >
      <div
        v-if="
          LedgerEntry.NumberOfLedgerEntriesSelected !== null &&
            LedgerEntry.NumberOfLedgerEntriesSelected >= ledgerEntryObj.id
        "
      >
        <div class="column">
          <b>Ledger Entry {{ ledgerEntryObj.id }}</b>
        </div>
        <div class="columns">
          <!-- <div class="column">
            <vee-textbox
              v-model="ledgerEntryObj.paymentDueDate"
              :name="`txt-ledger-${ledgerEntryObj.id}-payment-due-date`"
              placeholder="Payment Due Date"
              type="date"
            />
          </div> -->
          <div class="column">
            <vee-dropdown
              v-model="ledgerEntryObj.paymentMonth"
              :options="MultipleChoiceFieldOptions.Months"
              :name="`txt-ledger-${ledgerEntryObj.id}-payment-month`"
              placeholder="Payment Month"
              required
              rules="required"
              type="date"
            />
          </div>
          <div class="column">
            <vee-textbox
              v-model="ledgerEntryObj.paymentYear"
              :name="`txt-ledger-${ledgerEntryObj.id}-payment-year`"
              required
              rules="required"
              placeholder="Payment Year"
              @keydown.enter.prevent=""
            />
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <vee-textbox
              v-model="ledgerEntryObj.rentAmount"
              mode="eager"
              :name="`txt-ledger-${ledgerEntryObj.id}-rent-amount`"
              placeholder="Rent Amount"
              type="number"
              required
              rules="required|doubleCurrency"
            />
          </div>
          <div class="column">
            <vee-textbox
              v-model="ledgerEntryObj.rentAmountPaid"
              mode="eager"
              :name="`txt-ledger-${ledgerEntryObj.id}-rent-amount-paid`"
              placeholder="Rent Amount Paid"
              type="number"
              required
              rules="required|doubleCurrency"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <dropdown
              v-model="ledgerEntryObj.feeType"
              :options="MultipleChoiceFieldOptions.FeeTypes"
              :name="`txt-ledger-${ledgerEntryObj.id}-fee-type`"
              placeholder="Fee Type"
            />
          </div>
          <div class="column">
            <vee-textbox
              v-model="ledgerEntryObj.feesOwed"
              mode="eager"
              :name="`txt-ledger-${ledgerEntryObj.id}-fees-owed`"
              placeholder="Fees Owed"
              type="number"
              rules="doubleCurrency"
            />
          </div>
          <div class="column">
            <vee-textbox
              v-model="ledgerEntryObj.feeAmountPaid"
              mode="eager"
              :name="`txt-ledger-${ledgerEntryObj.id}-fee-amount-paid`"
              placeholder="Fee Amount Paid"
              type="number"
              rules="doubleCurrency"
            />
          </div>
          <div class="column">
            <dropdown
              v-model="ledgerEntryObj.feeType2"
              :options="MultipleChoiceFieldOptions.FeeTypes"
              :name="`txt-ledger-${ledgerEntryObj.id}-fee-type-2`"
              placeholder="Fee Type"
            />
          </div>
          <div class="column">
            <vee-textbox
              v-model="ledgerEntryObj.feesOwed2"
              mode="eager"
              :name="`txt-ledger-${ledgerEntryObj.id}-fees-owed-2`"
              placeholder="Fees Owed"
              type="number"
              rules="doubleCurrency"
            />
          </div>
          <div class="column">
            <vee-textbox
              v-model="ledgerEntryObj.feeAmountPaid2"
              mode="eager"
              :name="`txt-ledger-${ledgerEntryObj.id}-fee-amount-paid-2`"
              placeholder="Fee Amount Paid"
              type="number"
              rules="doubleCurrency"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <dropdown
              v-model="ledgerEntryObj.feeType3"
              :options="MultipleChoiceFieldOptions.FeeTypes"
              :name="`txt-ledger-${ledgerEntryObj.id}-fee-type-3`"
              placeholder="Fee Type"
            />
          </div>
          <div class="column">
            <vee-textbox
              v-model="ledgerEntryObj.feesOwed3"
              mode="eager"
              :name="`txt-ledger-${ledgerEntryObj.id}-fees-owed-3`"
              placeholder="Fees Owed"
              type="number"
              rules="doubleCurrency"
            />
          </div>
          <div class="column">
            <vee-textbox
              v-model="ledgerEntryObj.feeAmountPaid3"
              mode="eager"
              :name="`txt-ledger-${ledgerEntryObj.id}-fee-amount-paid-3`"
              placeholder="Fee Amount Paid"
              type="number"
              rules="doubleCurrency"
            />
          </div>
          <div class="column">
            <dropdown
              v-model="ledgerEntryObj.feeType4"
              :options="MultipleChoiceFieldOptions.FeeTypes"
              :name="`txt-ledger-${ledgerEntryObj.id}-fee-type-4`"
              placeholder="Fee Type"
            />
          </div>
          <div class="column">
            <vee-textbox
              v-model="ledgerEntryObj.feesOwed4"
              mode="eager"
              :name="`txt-ledger-${ledgerEntryObj.id}-fees-owed-4`"
              placeholder="Fees Owed"
              type="number"
              rules="doubleCurrency"
            />
          </div>
          <div class="column">
            <vee-textbox
              v-model="ledgerEntryObj.feeAmountPaid4"
              mode="eager"
              :name="`txt-ledger-${ledgerEntryObj.id}-fee-amount-paid-4`"
              placeholder="Fee Amount Paid"
              type="number"
              rules="doubleCurrency"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <dropdown
              v-model="ledgerEntryObj.feeType5"
              :options="MultipleChoiceFieldOptions.FeeTypes"
              :name="`txt-ledger-${ledgerEntryObj.id}-fee-type-5`"
              placeholder="Fee Type"
            />
          </div>
          <div class="column">
            <vee-textbox
              v-model="ledgerEntryObj.feesOwed5"
              mode="eager"
              :name="`txt-ledger-${ledgerEntryObj.id}-fees-owed-5`"
              placeholder="Fees Owed"
              type="number"
              rules="doubleCurrency"
            />
          </div>
          <div class="column">
            <vee-textbox
              v-model="ledgerEntryObj.feeAmountPaid5"
              mode="eager"
              :name="`txt-ledger-${ledgerEntryObj.id}-fee-amount-paid-5`"
              placeholder="Fee Amount Paid"
              type="number"
              rules="doubleCurrency"
            />
          </div>
          <div class="column">
            <dropdown
              v-model="ledgerEntryObj.feeType6"
              :options="MultipleChoiceFieldOptions.FeeTypes"
              :name="`txt-ledger-${ledgerEntryObj.id}-fee-type-6`"
              placeholder="Fee Type"
            />
          </div>
          <div class="column">
            <vee-textbox
              v-model="ledgerEntryObj.feesOwed6"
              mode="eager"
              :name="`txt-ledger-${ledgerEntryObj.id}-fees-owed-6`"
              placeholder="Fees Owed"
              type="number"
              rules="doubleCurrency"
            />
          </div>
          <div class="column">
            <vee-textbox
              v-model="ledgerEntryObj.feeAmountPaid6"
              mode="eager"
              :name="`txt-ledger-${ledgerEntryObj.id}-fee-amount-paid-6`"
              placeholder="Fee Amount Paid"
              type="number"
              rules="doubleCurrency"
            />
          </div>
        </div>
        <div class="columns">
          <div class="column">
            <vee-textbox
              v-model="ledgerEntryObj.Balance"
              mode="eager"
              disabled
              :name="`txt-ledger-${ledgerEntryObj.id}-balance`"
              placeholder="Balance"
              :value="`${ledgerEntryObj.Balance = (((ledgerEntryObj.rentAmount != null) ? Number(ledgerEntryObj.rentAmount) : 0) + ((ledgerEntryObj.feesOwed != null) ? Number(ledgerEntryObj.feesOwed) : 0) + ((ledgerEntryObj.feesOwed2 != null) ? Number(ledgerEntryObj.feesOwed2) : 0) + ((ledgerEntryObj.feesOwed3 != null) ? Number(ledgerEntryObj.feesOwed3) : 0) + ((ledgerEntryObj.feesOwed4 != null) ? Number(ledgerEntryObj.feesOwed4) : 0) + ((ledgerEntryObj.feesOwed5 != null) ? Number(ledgerEntryObj.feesOwed5) : 0) + ((ledgerEntryObj.feesOwed6 != null) ? Number(ledgerEntryObj.feesOwed6) : 0)) - (((ledgerEntryObj.rentAmountPaid != null) ? Number(ledgerEntryObj.rentAmountPaid) : 0) + ((ledgerEntryObj.feeAmountPaid != null) ? Number(ledgerEntryObj.feeAmountPaid) : 0) + ((ledgerEntryObj.feeAmountPaid2 != null) ? Number(ledgerEntryObj.feeAmountPaid2) : 0) + ((ledgerEntryObj.feeAmountPaid3 != null) ? Number(ledgerEntryObj.feeAmountPaid3) : 0) + ((ledgerEntryObj.feeAmountPaid4 != null) ? Number(ledgerEntryObj.feeAmountPaid4) : 0) + ((ledgerEntryObj.feeAmountPaid5 != null) ? Number(ledgerEntryObj.feeAmountPaid5) : 0) + ((ledgerEntryObj.feeAmountPaid6 != null) ? Number(ledgerEntryObj.feeAmountPaid6) : 0))}`"
            />
          </div>
          <div class="column">
            <vee-textbox
              v-model="ledgerEntryObj.totalAmount"
              mode="eager"
              disabled
              :name="`txt-ledger-${ledgerEntryObj.id}-total-amount`"
              placeholder="Total Amount"
              :value="`${ledgerEntryObj.totalAmount = (((ledgerEntryObj.rentAmount != null) ? Number(ledgerEntryObj.rentAmount) : 0) + ((ledgerEntryObj.feesOwed != null) ? Number(ledgerEntryObj.feesOwed) : 0) + ((ledgerEntryObj.feesOwed2 != null) ? Number(ledgerEntryObj.feesOwed2) : 0) + ((ledgerEntryObj.feesOwed3 != null) ? Number(ledgerEntryObj.feesOwed3) : 0) + ((ledgerEntryObj.feesOwed4 != null) ? Number(ledgerEntryObj.feesOwed4) : 0) + ((ledgerEntryObj.feesOwed5 != null) ? Number(ledgerEntryObj.feesOwed5) : 0) + ((ledgerEntryObj.feesOwed6 != null) ? Number(ledgerEntryObj.feesOwed6) : 0))}`"
            />
          </div>
        </div>
        <!-- <callout
          type="danger"
          style="margin-left: 1%;"
        >
          *Be sure the balance due listed on the ledger matches the arrears you put on the application and that they are true and accurate. By clicking Submit . . .
        </callout> -->
      </div>
    </div>
    <!--{{ LedgerEntry.ledgerEntryList[0].amountOwed }}
    {{ LedgerEntry.ledgerEntryList[0].paymentDueDate }}-->
    <div class="column">
      <callout type="info">
        By clicking on 'Submit', you are agreeing to the arrears amount owed and waiving any additional amount not listed on the application.
      </callout>
      <p><b>Once you have completed filling out the ledger, you must click 'Submit' to upload it.</b></p>
      <div
        class="column is-2 is-offset-20"
        style="margin-top:2%"
      >
        <button
          class="button is-primary"
          :disabled="SubmitStatus.Value === 'PENDING' || SubmitStatus.Value === 'OK'"
          @click="handleEntryUpload(LedgerEntry.ledgerEntryList, LedgerEntry.NumberOfLedgerEntriesSelected, applicantId)"
        >
          Submit
        </button><br><br>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {
  dataObjectToXml,
  getPropertyValueOrDefault,
} from "@/utilities/functions";
import options from "@/utilities/options";
import LedgerEntry from "@/utilities/classes/ledgerEntry";
import buildLedgerDataObject from "@/utilities/data-objects/ledger-data-object";
import buildLandlordDataFetchObject from "@/utilities/data-objects/landlord-data-fetch-object";
import { Callout } from "@phila/phila-ui";
//import { parseRule } from "vee-validate/dist/types/utils/rules";

export default {
  name: "Ledger",
  components: { Callout },
  mixins: [options],
  props: {
    applicantId: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      LedgerEntry: {
        entriesGenerated: false,
        ledgerEntryList: [],
        NumberOfLedgerEntriesSelected: null,
        paymentDueDate: null,
        rentAmount: null,
        amountDue: null,
        feesOwed: null,
        totalAmount: null,
        ledgerAmountOwed: null,
        Arrears: null,
        RentOrFeesOwed: null,
        TFAOtpIn: null,
      },
      LandlordRecordID: null,
      Arrears: null,
      PropertyInfoProvider: null,
    };
  },
  computed: {
    calculateLedgerAmount: function () {
      let result = 0;
      for (let i = 0; i < this.LedgerEntry.NumberOfLedgerEntriesSelected; i++) {
        /*let currentEntryAmount = this.LedgerEntry.ledgerEntryList[i].amountOwed;  MARKS CODE FOR HOW TO AUTO CALCULATE AS YOU FILL IN
                if (currentEntryAmount == null) {
                  currentEntryAmount = 0;
                }
                result += parseFloat(currentEntryAmount);*/
        result += parseFloat(this.LedgerEntry.ledgerEntryList[i].totalAmount); //ORIGINAL CODE THAT FORCES YOU TO ENTER ALL ENTRIES BEFORE COMPUTING
      }
      return parseFloat(result.toFixed(2));
    },
    calculateBalance: function () {
      let result = 0;

      for(let i = 0; i < this.LedgerEntry.NumberOfLedgerEntriesSelected; i++){
        result += parseFloat(this.LedgerEntry.ledgerEntryList[i].Balance);
      }
      return parseFloat(result.toFixed(2));
    },
  },
  created() {
    var vData = this;
    for (let i = 0; i < vData.NumberOfLedgerEntries; i++) {
      const ledgerEntryObj = new LedgerEntry(i + 1);
      vData.LedgerEntry.ledgerEntryList.push(ledgerEntryObj);
    }
    const dataObject = buildLandlordDataFetchObject(vData.applicantId, "TFA_TENANT_PAGE_GET_LANDLORD_DATA"); //CHANGE UDATA NAME FOR CONSISTENCY
    const requestObj = {
      table: process.env.VUE_APP_QB_APPLICATION,
      data: dataObject,
    };
    axios //add try catch for finding application id
      .post("https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/V1/EDP-TFA-login-QuickBase-Request-Proxy-Reads", requestObj)
      .then((response) => {
        const responseObject = getPropertyValueOrDefault(["data", "record", "f"], response);
        vData.Arrears = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "65"));
        vData.RentOrFeesOwed = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "64"));
        vData.LedgerEntry.TFAOtpIn = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "73"));
        vData.LandlordRecordID = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "3"));
        vData.PropertyInfoProvider = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "1069"));

        if(vData.Arrears == null || vData.Arrears == ""){
          vData.Arrears = 0;
        }
      });
  },
  methods: {
    entriesSelected() {
      return this.entriesGenerated = true;
    },
    async handleEntryUpload(uploadData, entryIdx) {
      var vData = this;
      vData.SubmitStatus.Value = vData.SubmitStatus.Options.PENDING;
      if (uploadData.length) {
        for (var i = 0; i < entryIdx; i++) {
          const dataObject = buildLedgerDataObject(uploadData[i].rentAmount, uploadData[i].paymentDueDate, uploadData[i].paymentMonth, uploadData[i].paymentYear, uploadData[i].rentAmountPaid, uploadData[i].totalAmount, uploadData[i].feesOwed, uploadData[i].feeAmountPaid, uploadData[i].feeType, uploadData[i].feesOwed2, uploadData[i].feeAmountPaid2, uploadData[i].feeType2, uploadData[i].feesOwed3, uploadData[i].feeAmountPaid3, uploadData[i].feeType3, uploadData[i].feesOwed4, uploadData[i].feeAmountPaid4, uploadData[i].feeType4, uploadData[i].feesOwed5, uploadData[i].feeAmountPaid5, uploadData[i].feeType5, uploadData[i].feesOwed6, uploadData[i].feeAmountPaid6, uploadData[i].feeType6, vData.applicantId, vData.LandlordRecordID);
          const xmlDataObject = dataObjectToXml(dataObject);
          const requestObj = {
            table: process.env.VUE_APP_QB_LEDGER,
            action: "API_AddRecord",
            data: xmlDataObject,
          };
          axios
            .post("https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/V1/Eviction-Diversion-login-QuickBase-Request-Proxy", requestObj)
            .then((response) => {
              vData.SubmitStatus.Value = vData.SubmitStatus.Options.OK;
              console.log(response);
              
              vData.$router.push({
                name: "LandlordSuccessPage",
              });
              
            });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.columns,
.column,
.content div {
  margin-bottom: 0;
}
.address-label {
  padding-left: 5px;
}
</style>
